import client, { deserializer } from 'services/client'
import { toSnake, toCamel } from 'change-object-case'

async function getTearsheetCustomTemplates(params) {
  const response = await client().get(`v2/tearsheets/custom_templates`, {
    params: toSnake(params),
  })
  return toCamel(deserializer.deserialize(response), { recursive: true })
}

async function createTearsheetCustomTemplate(params) {
  const response = await client().post(
    'v2/tearsheets/custom_templates',
    toSnake(params, { recursive: true }),
  )
  return deserializer.deserialize(response)
}

async function updateTearsheetCustomTemplate(params) {
  const { id, ...rest } = params
  const response = await client().put(
    `v2/tearsheets/custom_templates/${id}`,
    toSnake(rest, { recursive: true }),
  )
  return deserializer.deserialize(response)
}

async function deleteTearsheetCustomTemplate(id) {
  return client().delete(`v2/tearsheets/custom_templates/${id}`)
}

async function getCustomTearsheetTemplateRequests(params) {
  const response = await client().get('v2/tearsheets/custom_template_requests', {
    params: toSnake(params),
  })
  return {
    data: deserializer.deserialize(response),
    meta: toCamel(response.meta, { recursive: true, arrayRecursive: true }),
  }
}

async function getCustomTemplateRequestResourceLink(id, filePath) {
  const response = await client().get(`v2/tearsheets/custom_template_requests/${id}/download`, {
    params: { file_path: filePath },
  })
  return toCamel(response, { recursive: true })
}

export {
  getTearsheetCustomTemplates,
  createTearsheetCustomTemplate,
  updateTearsheetCustomTemplate,
  deleteTearsheetCustomTemplate,
  getCustomTearsheetTemplateRequests,
  getCustomTemplateRequestResourceLink,
}
